// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CommentsLoader-module_commentsLoader_Up3rlqQdKEHwWa2fKmgs{padding-block-start:.75rem}", "",{"version":3,"sources":["webpack://./src/features/comments/components/CommentsLoader.module.scss"],"names":[],"mappings":"AACA,2DACE,0BAAA","sourcesContent":["@import \"src/styles/theme.scss\";@import \"~cx-web-themes/crunchyroll/abstracts/main\";\n.commentsLoader {\n  padding-block-start: 0.75rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commentsLoader": "CommentsLoader-module_commentsLoader_Up3rlqQdKEHwWa2fKmgs"
};
export default ___CSS_LOADER_EXPORT___;
